module.exports = __webpack_public_path__ + "static/crazy-work-guy-o.33db5cbf.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/git-github-presentation/crazy-work-guy-o.gif
// module id = 1062
// module chunks = 32308089046778